type Platform = 'android' | 'ios' | 'desktop';

export const getDetectedPlatform = (): Platform => {
  let detectedPlatform: Platform;
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('android')) {
    detectedPlatform = 'android';
  } else if (/iphone|ipad|ipod/.test(userAgent)) {
    detectedPlatform = 'ios';
  } else {
    detectedPlatform = 'desktop';
  }
  return detectedPlatform;
};
